<template>
  <div class="person__info">
    <h3
      v-for="hasLabel in renderIf(label)"
      :key="hasLabel"
      role="none"
      class="person__title"
      v-text="label"
    />
    <p class="person__data-container">
      <template v-for="(item, index) in list"
        ><component
          v-for="hasComponent in renderIf(hasItemscope || getLink(item))"
          :key="hasComponent"
          v-bind:is="getLink(item) ? 'a' : 'span'"
          :role="getLink(item) ? 'link' : false"
          :href="getLink(item)"
          :class="{ person__link: getLink(item), person__data: !getLink(item) }"
          :itemscope="hasItemscope"
          :itemprop="hasItemscope ? 'address' : false"
          :itemtype="hasItemscope ? 'https://schema.org/PostalAddress' : false"
          v-html="getLabel(item)"
        />{{ getFallbackItem(item) + getSeparator(separator, list, index) }}
      </template>
    </p>
  </div>
</template>

<script>
import helpers from '@/assets/js/shared/misc/helpers';
import getStatesList from '@/assets/js/shared/helpers/getStatesList';

const states = getStatesList({ hasTerritories: false });
const stateList = [];

Object.entries(states).forEach(([key, val]) => {
  stateList.push({
    name: val,
    value: key
  });
});

export default {
  name: 'wl-person-list-address',
  methods: {
    /**
     * If statement vue hack to prevent <!-- --> comment
     * @param condition
     * @returns {[]}
     */
    renderIf(condition) {
      return helpers.renderIf(condition);
    },
    /**
     * Is there a list item link?
     * @param {string|object} item
     * @returns {boolean}
     */
    getLink(item) {
      if (!item || !item.url) return false;

      const isValidState = stateList.some(state => state.value === item.state);
      if (!isValidState) return false;

      const poBoxArray = ['PO BOX', 'P.O', 'P/O', 'POST OFFICE BOX'];
      const isPoBox = poBoxArray.some(poBox =>
        item.street.toUpperCase().includes(poBox)
      );
      if (isPoBox) return false;

      return item.url;
    },
    /**
     * Get the list item label
     * @param {string|object} item
     * @returns {string|boolean}
     */
    getLabel(item) {
      let street = item.street ? `${item.street}, ` : '';
      let cityState =
        item.city && item.state ? `${item.city}, ${item.state} ` : '';
      let zip = item.zip ? item.zip : '';

      if (this.hasItemscope && item.street) {
        street = `<span itemprop="streetAddress">${item.street}</span>, `;
      }

      if (this.hasItemscope && item.city && item.state) {
        cityState = `<span itemprop="addressLocality">${item.city}</span>, <span itemprop="addressRegion">${item.state}</span>`;
      }

      if (this.hasItemscope && item.zip) {
        zip = ` <span itemprop="postalCode">${item.zip}</span>`;
      }

      return street + cityState + zip;
    },
    /**
     * Get the separator for the list items
     * @param {string} separator
     * @param {array} list
     * @param {number} index
     * @returns {string}
     */
    getSeparator(separator, list, index) {
      return list.length === index + 1 ? '' : separator;
    },
    /**
     * Get fall back item if there's no itemscope or link (should just be plain text)
     * @param item
     * @returns {string}
     */
    getFallbackItem(item) {
      return this.hasItemscope || this.getLink(item) ? '' : this.getLabel(item);
    }
  },
  props: {
    // Label used for the list
    label: {
      type: String,
      required: false
    },
    /*
      An array of objects (ex: {"street": "3602 Cape Ct", "city": "Saint Cloud", "state": "FL", "zip": "34772", "url": "/Efrain-Lugo"})
     */
    list: {
      type: Array,
      required: true
    },
    // Separator used after every list item
    separator: {
      type: String,
      required: false,
      default: ', '
    },
    // Wrap parts of the address in span tags adding itemprop values
    hasItemscope: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>
